import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=419cb4a7&scoped=true&"
import script from "./PermissionsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419cb4a7",
  null
  
)

export default component.exports